import {Panel} from "../Panel";
import {Box, Grid, makeStyles, Typography} from "@material-ui/core";
import React, {useContext} from "react";
import {themeContext} from "@smartb/archetypes-ui-components";
import {InfoBox} from "../InfoBox";

const useStyles = makeStyles(() => ({
  panel: {
    width: '100%',
    height: '100%',
    '& .ColisactivPanel-content': {
      padding: '15px !important'
    }
  },
  indicator: {
    color: '#353945',
    fontWeight: 600,
    textAlign: 'left',
    fontSize: '17px',
    lineHeight: '24px',
    marginBottom: '5px',
  },
  description: {
    fontSize: '14px',
    lineHeight: '17px',
    color: '#353945'
  },
  icon: {
    width: '30px',
    height: '30px',
    marginBottom: '20px'
  },
  infoIcon: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    top: '10px',
    right: '10px'
  },
  tooltip: {
    fontSize: '12px',
    color: '#828282',
    whiteSpace: 'pre-line'
  }
}))

interface IconProps {
  className?: string
  color?: string
}

interface DashboardGridItemProps {
  icon: React.ComponentType<IconProps>
  indicator: React.ReactNode
  description: React.ReactNode
  tooltip?: React.ReactNode
  display?: boolean
}

export const DashboardGridItem = ({ icon: Icon, indicator, description, tooltip, display = true }: DashboardGridItemProps) => {
  const classes = useStyles()
  const theme = useContext(themeContext)

  if (!display) {
    return <></>
  }

  return <Grid item xs={4}>
    <Panel className={classes.panel}>
      <Icon className={classes.icon} color={theme.primaryColor} />
      {tooltip && <InfoBox
        className={classes.infoIcon}
        content={
          <Box display='flex' flexDirection='column'>
            <Typography
              variant='body2'
              className={classes.tooltip}
            >
              {tooltip}
            </Typography>
          </Box>
        }
      />}
      <Box
        display='flex'
        flexDirection='column'
      >
        <Typography
          variant='body1'
          className={classes.indicator}
        >
          {indicator}
        </Typography>

        <Typography
          variant='body1'
          className={classes.description}
        >
          {description}
        </Typography>
      </Box>
    </Panel>
  </Grid>
}
